import { shallowMemoize } from '@sail/utils';
import createGlobalizeWithLocale from '../../internal/createGlobalizeWithLocale/createGlobalizeWithLocale';
import resolveStyle from '../../internal/date-formatter/resolveStyle';
import handleGlobalizeError from '../../internal/errors/handleGlobalizeError/handleGlobalizeError';
import getLocaleData from '../../internal/getLocaleData';
import mergeOptions from '../../internal/mergeOptions';
const dateFormatter = shallowMemoize((config, locale, timeZone, style, reports)=>{
    var _getLocaleData_dateTimeStyles;
    const globalize = createGlobalizeWithLocale(config, locale, timeZone, reports);
    const raw = (_getLocaleData_dateTimeStyles = getLocaleData(locale, config, reports).dateTimeStyles) === null || _getLocaleData_dateTimeStyles === void 0 ? void 0 : _getLocaleData_dateTimeStyles[style];
    try {
        return globalize.dateFormatter({
            timeZone,
            raw
        });
    } catch (error) {
        handleGlobalizeError(error, reports);
    }
});
/**
 * @see https://sail.stripe.me/apis/intl/useIntl/#format-date-time
 */ export default function formatDateTime(/** The intl config object containing the locale data. When using this API through the `useIntl` hook, this config object is automatically injected. */ config, reports, analytics, /** The date to be formatted. */ date, /** An object with options to customize the formatting. */ options) {
    const defaults = {
        style: 'short-year-month-day-time',
        timeZone: config.timeZone,
        locale: config.locale
    };
    const mergedOptions = mergeOptions(config, defaults, reports, options);
    // Etc/Unknown is a non-existing timezone, but we have a non-trivial amount
    // of users hitting us with it. So we re-map it to UTC, which is the best we
    // can do.
    if (mergedOptions.timeZone === 'Etc/Unknown') {
        mergedOptions.timeZone = 'Etc/UTC';
    }
    const style = resolveStyle(date, mergedOptions, config, reports, analytics);
    const formatter = dateFormatter(config, mergedOptions.locale, mergedOptions.timeZone, style, reports);
    return formatter(typeof date === 'number' ? new Date(date) : date);
}

//# sourceMappingURL=formatDateTime.js.map